var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVulnerabilityTotalTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4584 3.97307C10.193 1.97098 6.77772 1.97098 4.51228 3.97307L8.48535 7.94614L12.4584 3.97307Z",
    fill: "#D20A04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9976 12.4584C14.9997 10.193 14.9997 6.77772 12.9976 4.51228L9.02457 8.48535L12.9976 12.4584Z",
    fill: "#D8B200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.51228 12.9976C6.77772 14.9997 10.193 14.9997 12.4584 12.9976L8.48535 9.02457L4.51228 12.9976Z",
    fill: "#E66400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97307 4.51228C1.97098 6.77772 1.97098 10.193 3.97307 12.4584L7.94614 8.48535L3.97307 4.51228Z",
    fill: "#E83646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnerabilityTotalTable);
export default __webpack_public_path__ + "static/media/vulnerability_total_table.81a82a51d4cac7db74e56733bac2de8b.svg";
export { ForwardRef as ReactComponent };